import { Component } from '@angular/core';
import { Http } from '@angular/http';
import {
  NavController,
  ToastController,
  ModalController,
  LoadingController,
  NavParams,
  IonicPage
} from 'ionic-angular';
import { PodcastService } from '../../providers/podcast-service';
import { AudioService } from '../../providers/audio-service';

import { API_TIMEOUT } from '../../providers/config';

@IonicPage()
@Component({
  selector: 'page-episode-list',
  templateUrl: 'episode-list.html'
})

export class EpisodeListPage {
  podcast: any = null;
  tracks: any[];
  navTitle: 'Episodes';

  constructor(
    public navCtrl: NavController, public loadingCtrl: LoadingController,
    public toastCtrl: ToastController, public modalCtrl: ModalController,
    public navParams: NavParams, public http: Http,
    public podcastService: PodcastService, public audioService: AudioService
  ) {
    let loader = this.loadingCtrl.create({
      content: 'Loading episodes...',
      duration: API_TIMEOUT
    });
    loader.present();
    // load initial data
    this.reloadData().then((episodes: any[]) => {
      this.tracks = episodes;
      loader.dismiss();
    });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad EpisodeListPage');
  }

  // for pull-to-refresh
  doRefresh(refresher) {
    this.reloadData().then((episodes: any[]) => {
      this.tracks = episodes;
      refresher.complete();
    });
  }

  // reload list data
  reloadData() {
    return new Promise(resolve => {
      // saving podcast as param
      this.podcast = this.navParams.get('podcast');
      if (this.podcast) {
        // fetching episodes
        this.podcastService.episodes(this.podcast._id).subscribe((episodes: any[]) => {
          resolve(episodes);
        });
      } else {
        alert('no podcast!');
      }
    });
  }

  doInfinite(infiniteScroll) {
    if (this.podcast) {
      // skipping current number of tracks
      this.podcastService.episodes(this.podcast._id, this.tracks.length).subscribe((episodes: any[]) => {
        // merge results with track list
        Array.prototype.push.apply(this.tracks, episodes);
        infiniteScroll.complete();
      });
    }
  }

  listen(event, episode) {
    this.audioService.playTrack(episode);
  }

}



// WEBPACK FOOTER //
// ./src/pages/episode-list/episode-list.ts